import { render, staticRenderFns } from "./MedecinShow.vue?vue&type=template&id=4eec95cf&scoped=true&"
import script from "./MedecinShow.vue?vue&type=script&lang=js&"
export * from "./MedecinShow.vue?vue&type=script&lang=js&"
import style0 from "./MedecinShow.vue?vue&type=style&index=0&id=4eec95cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec95cf",
  null
  
)

export default component.exports